import React, { Fragment } from "react";

function About() {
  return (
    <Fragment>
      <h1>About This App</h1>
      <p>App to search Github users</p>
      <p>Version: 1.0.0</p>
    </Fragment>
  );
}

export default About;
